import { combineReducers } from "redux";
import MFOrderBookHoldingsReducer from "./mfOrderBookHoldings";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
export default combineReducers({
    reducersData: MFOrderBookHoldingsReducer,
    commonData: commonReducer,
});
